<div class="auth-login">
  <main class="auth-login__container">
    <header class="auth-login__brand">
      <img class="auth-login__logo" ngSrc="brands/brand.png" width="190" height="36" alt="CLASS" priority />
      <p class="auth-login__product">ERPClass Dash</p>
    </header>
    <section class="auth-login__card" aria-labelledby="auth-shell-title">
      <div class="auth-login__heading">
        @if (icon()) {
        <span class="auth-login__icon" [class.auth-login__icon--success]="iconTone() === 'success'" [class.auth-login__icon--danger]="iconTone() === 'danger'">
          <i [class]="icon()" aria-hidden="true"></i>
        </span>
        }
        <h1 id="auth-shell-title" class="auth-login__title">{{ title() }}</h1>
        @if (subtitle()) {
        <p class="auth-login__subtitle">{{ subtitle() }}</p>
        }
      </div>
      <ng-content />
    </section>
    <footer class="auth-login__footer">
      <ng-content select="[authShellFooter]" />
      <p class="auth-login__legal">
        <a [routerLink]="['/termos']">Termos de Uso</a>
        ·
        <a [routerLink]="['/privacidade']">Política de Privacidade</a>
      </p>
    </footer>
  </main>
</div>
